export default __webpack_public_path__ + "static/media/S-027.84bd9279.png";